import { createContext, forwardRef, useContext, type AnchorHTMLAttributes } from "react";

type LinkComponent = React.ForwardRefExoticComponent<
  { to: string; className?: string; children?: React.ReactNode } & React.RefAttributes<HTMLAnchorElement>
>;

const LinkContext = createContext<LinkComponent | null>(null);

export function LinkProvider({ Link, children }: { Link: LinkComponent; children: React.ReactNode }) {
  return <LinkContext.Provider value={Link}>{children}</LinkContext.Provider>;
}

/** Falls back to a plain <a> tag if no LinkProvider is set up. */
export const Link = forwardRef<HTMLAnchorElement, { to: string; className?: string; children?: React.ReactNode }>(
  ({ to, children, ...props }, ref) => {
    const ProvidedLink = useContext(LinkContext);
    if (ProvidedLink) {
      return <ProvidedLink to={to} ref={ref} className="hover:underline text-[#376fd0]" {...props}>{children}</ProvidedLink>;
    }
    return <a href={to} ref={ref} className="hover:underline text-[#376fd0]" {...props}>{children}</a>;
  }
);
